import { render, staticRenderFns } from "./IdeaIcon.vue?vue&type=template&id=1eed1fdd&scoped=true&"
import script from "./IdeaIcon.vue?vue&type=script&lang=ts&"
export * from "./IdeaIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eed1fdd",
  null
  
)

export default component.exports